import React from 'react';
import { View, ViewStyle, Dimensions } from 'react-native';
import { useTheme } from 'react-native-paper';

interface ResponsiveLayoutWrapperProps {
  children: React.ReactNode;
  style?: ViewStyle;
}

/**
 * ResponsiveLayoutWrapper - Centers content on larger screens with maxWidth constraint
 *
 * Features:
 * - Centers content when screen width > 768px
 * - Applies maxWidth of 700px for optimal reading experience
 * - Full width on mobile devices (≤ 768px)
 * - Responsive to orientation changes
 */
export function ResponsiveLayoutWrapper({
  children,
  style,
}: ResponsiveLayoutWrapperProps) {
  const theme = useTheme();
  const [isLargeScreen, setIsLargeScreen] = React.useState(false);

  React.useEffect(() => {
    const updateScreenSize = () => {
      const { width } = Dimensions.get('window');
      setIsLargeScreen(width >= 768);
    };

    updateScreenSize(); // Set initial value

    const subscription = Dimensions.addEventListener(
      'change',
      updateScreenSize
    );
    return () => subscription?.remove();
  }, []);

  const containerStyle: ViewStyle = {
    flex: 1,
    ...(isLargeScreen && {
      maxWidth: 550,
      alignSelf: 'center',
      width: '100%',
      borderLeftWidth: 1,
      borderRightWidth: 1,
      borderLeftColor: (theme.colors.outline || '#e0e0e0') + '40',
      borderRightColor: (theme.colors.outline || '#e0e0e0') + '40',
    }),
  };

  return <View style={[containerStyle, style]}>{children}</View>;
}
